import React, { Component } from "react";
import Box from "@mui/material/Box";

class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_visible: false
    };
  }

  componentDidMount() {
    document.addEventListener("scroll", this.toggleVisibility);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.toggleVisibility);
  }

  toggleVisibility = () => {
    this.setState({
      is_visible: window.pageYOffset > 300
    });
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  render() {
    const { is_visible } = this.state;

    const scrollToTopStyle = {
      position: "fixed",
      bottom: "3rem",
      right: "0.5rem",
      cursor: "pointer",
      animation: "fadeIn 700ms ease-in-out 1s both",
      zIndex: 1000
    };

    return (
      <Box sx={scrollToTopStyle}>
        {is_visible && (
          <Box onClick={this.scrollToTop} component="div">
            <svg xmlns="http://www.w3.org/2000/svg" height="38.735" width="33.749">
              <g transform="translate(-18.121 -3.364)">
                <rect ry="4.928" y="3.364" x="18.121" height="38.735" width="33.749" fill="#A9A9A9" />
                <g transform="translate(-.48 2.134)">
                  <rect ry="4.928" y="1.229" x="18.601" height="38.735" width="33.749" fill="url(#b)" />
                  <g fill="#ececec">
                    <path d="M22.435 17.62l4.684 4.685 5.044-5.044v19.352h6.625V17.26l5.044 5.044 4.683-4.684-13.04-13.04z" />
                    <path d="M22.435 17.62l4.684 4.685 5.044-5.044v19.352h6.625V17.26l5.044 5.044 4.683-4.684-13.04-13.04z" />
                  </g>
                </g>
              </g>
            </svg>
          </Box>
        )}
      </Box>
    );
  }
}

export default ScrollToTop;
